exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rWHXV{font-size:10px;position:relative;top:-8px}._2zR1s{min-width:300px;max-width:700px;width:80%;display:block;margin:var(--block--spacing) auto;margin:var(--block--spacing) auto}", ""]);

// exports
exports.locals = {
	"cite": "rWHXV",
	"chart": "_2zR1s"
};